import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c31bb16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "setting-main-top" }
const _hoisted_3 = { class: "main_title" }
const _hoisted_4 = { class: "header-left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow_b",
  src: "/assets/icon/btn_back.png",
  srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 설정 ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-margin" }, null, -1))
const _hoisted_8 = { class: "main_content" }
const _hoisted_9 = { class: "content_row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 간편 비밀번호 변경 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_right_bk.png",
  srcset: "/assets/icon/btn_right_bk@2x.png 2x,/assets/icon/btn_right_bk@3x.png 3x"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_info" }, " 본인인증을 다시 진행한 후 변경이 가능합니다. ", -1))
const _hoisted_14 = { class: "content_row" }
const _hoisted_15 = { class: "row_box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row_text" }, " 토론 게시판 알림 ", -1))
const _hoisted_17 = { class: "view_money_switch" }
const _hoisted_18 = ["checked"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "view_money_slider round" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "row_info"
}
const _hoisted_21 = {
  key: 1,
  class: "row_info"
}
const _hoisted_22 = { class: "bottom_wrap" }
const _hoisted_23 = { class: "btn_groups space-between" }
const _hoisted_24 = { class: "space-between black" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " · ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "앱정보 v 2.0.1", -1))
const _hoisted_27 = { class: "delete_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_link_account_modal = _resolveComponent("link-account-modal")!
  const _component_agree_to_use_personal_info = _resolveComponent("agree-to-use-personal-info")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent btn-back",
                    onClick: _cache[0] || (_cache[0] = () => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'헤더', 'clickContent':'뒤로가기'})
                  _ctx.router.push({ path: '/tabs/mypage'})
                })
                  }, [
                    _hoisted_5,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ]),
                  _hoisted_6
                ])
              ])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_link_account_modal, {
                "model-value": _ctx.linkAccountModal,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _ctx.linkAccountModal = value),
                onComplete: _ctx.refreshLinkData
              }, null, 8, ["model-value", "onComplete"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "row_box",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'간편비밀번호변경'}); _ctx.askPassword()})
                }, _hoisted_12),
                _hoisted_13
              ]),
              _createVNode(_component_agree_to_use_personal_info, {
                "model-value": _ctx.agreeModalOpen,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => _ctx.agreeModalOpen = $event)
              }, null, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("label", _hoisted_17, [
                    _createElementVNode("input", {
                      id: "moneyCheckBox",
                      type: "radio",
                      checked: _ctx.agreeMarketingValue === true || _ctx.agreeMarketingValue === 1? true : false,
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'상단영역', 'clickContent':'마케팅정보수신'}); _ctx.agreeMarketing()}, ["prevent"]))
                    }, null, 8, _hoisted_18),
                    _hoisted_19
                  ])
                ]),
                (_ctx.agreeMarketingValue === true || _ctx.agreeMarketingValue === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 토론 게시판의 피드백에 대한 알림입니다. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, " 신규 클럽딜, 회사 정보 받으시려면 동의해주세요.(선택) "))
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  class: "common_btn white_btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'로그아웃'}); _ctx.logout()})
                }, " 로그아웃 "),
                _createElementVNode("button", {
                  id: "custom-channel-io",
                  class: "common_btn navy_btn custom-channel-io",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'1:1문의'}); _ctx.openChannelTalk();})
                }, " 1:1 문의 ")
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'이용약관'});
                  _ctx.openLink('https://www.notion.so/angelleague/03d3a6fa9e0e41bb864d8289720bc52b')})
                  }, "이용약관"),
                  _hoisted_25,
                  _createElementVNode("span", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {
                  _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'개인정보처리방침'});
                  _ctx.openLink('https://www.notion.so/angelleague/cd4f32d98c4142f0858478c16de78c2f')})
                  }, "개인정보처리방침")
                ]),
                _hoisted_26
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", {
                  class: "red",
                  onClick: _cache[9] || (_cache[9] = () => {
                _ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼영역', 'clickContent':'회원탈퇴'})
                _ctx.router.push('/delete-account')
              })
                }, "회원탈퇴 >")
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}